import { useTranslation } from 'react-i18next';
import { ExoVariants } from '../exo/ExoVariants';
import { NewDefaultEmailIntegration } from './NewDefaultEmailIntegration';
import EmailIcon from '@mui/icons-material/Email';
import GoogleIcon from '@mui/icons-material/Google';
import { NewGoogleEmailIntegration } from './NewGoogleEmailIntegration';

export const NewEmailIntegration = ({
  onChange,
  onDelete,
  userId,
  startData,
  onClose,
  debug,
}) => {
  const { t } = useTranslation();

  const variants = [
    {
      label: t('IMAP/SMTP'),
      Icon: EmailIcon,
      content: (
        <NewDefaultEmailIntegration
          onChange={onChange}
          onDelete={onDelete}
          userId={userId}
          startData={startData}
          onClose={onClose}
          debug={debug}
        />
      ),
    },
    {
      label: t('GMail'),
      Icon: GoogleIcon,
      content: <NewGoogleEmailIntegration onClose={onClose} />,
    },
  ];

  return <ExoVariants variants={variants} />;
};
